import styled from 'styled-components';

const SelectionContainer = styled.div`
  align-items: center;
  display: flex;
  height: 3rem;
  padding: 0 0.5rem;
  justify-content: space-between;
  width: 100%;
  flex: 1 1 auto;
  line-height: 1.2;
`;

export default SelectionContainer;
